import { TrackingEventLabels as BaseTrackingEventLabels } from '../../common/tracking/tracking-event-labels.model';

export const TrackingEventLabels = {
  ...BaseTrackingEventLabels,
  NAVIGATE_TO_DEVICES_MASTER_VIEW: 'navigate_to_devices_master_view',
  NAVIGATE_TO_DEVICE_OVERVIEW_PAGE: 'navigate_to_device_info_page',
  OPEN_DEVICE_CLOCK_EDIT_FORM: 'open_device_clock_edit_form',
  OPEN_DEVICE_CREDENTIALS_EDIT_FORM: 'open_device_credentials_edit_form'
};
